import script from "./AppBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBackButton.vue?vue&type=script&setup=true&lang=js"

import "./AppBackButton.vue?vue&type=style&index=0&id=6be11bbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be11bbe"]])

export default __exports__